var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7806 4.99935V4.33268C11.7806 3.39926 11.7806 2.93255 11.5989 2.57603C11.4392 2.26243 11.1842 2.00746 10.8706 1.84767C10.5141 1.66602 10.0474 1.66602 9.11393 1.66602H7.7806C6.84718 1.66602 6.38047 1.66602 6.02395 1.84767C5.71034 2.00746 5.45538 2.26243 5.29559 2.57603C5.11393 2.93255 5.11393 3.39926 5.11393 4.33268V4.99935M6.7806 9.58268V13.7493M10.1139 9.58268V13.7493M0.947266 4.99935H15.9473M14.2806 4.99935V14.3327C14.2806 15.7328 14.2806 16.4329 14.0081 16.9677C13.7684 17.4381 13.386 17.8205 12.9156 18.0602C12.3808 18.3327 11.6807 18.3327 10.2806 18.3327H6.61393C5.2138 18.3327 4.51374 18.3327 3.97896 18.0602C3.50855 17.8205 3.1261 17.4381 2.88642 16.9677C2.61393 16.4329 2.61393 15.7328 2.61393 14.3327V4.99935",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNb);
export default __webpack_public_path__ + "static/media/DeleteNB.2a1a05ccdac14687a676bb9cebc9e3b4.svg";
export { ForwardRef as ReactComponent };